import { useNavigate } from "react-router-dom";
import axios from "axios";
import useAuthStore from "../Zustand/Store/useAuthStore";
import { MAIN_URL } from "../Configurations/Urls";
import { clearClientPreferredOrganizationId } from "../Utils/clientActiveOrganization";

const NotAllowed = () => {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    try {
      if (token) {
        await axios.get(`${MAIN_URL}/api/auth/logout`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch {
      // Continue local logout even if API call fails.
    }
    logout();
    localStorage.removeItem("token");
    clearClientPreferredOrganizationId();
    navigate("/login", { replace: true });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f8f9fa",
        color: "#333",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "40px",
          borderRadius: "10px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          maxWidth: "500px",
          width: "100%",
        }}
      >
        <h1 style={{ fontSize: "5rem", marginBottom: "10px", color: "#dc3545" }}>
          403
        </h1>
        <h2 style={{ fontSize: "1.8rem", marginBottom: "15px" }}>
          Access Denied
        </h2>
        <p style={{ fontSize: "1rem", color: "#666", marginBottom: "30px" }}>
          You do not have permission to view this page.
        </p>

        <div style={{ display: "flex", gap: "15px", justifyContent: "center", flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              padding: "10px 20px",
              backgroundColor: "#6c757d",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Go Back
          </button>
          <button
            type="button"
            onClick={() => navigate("/")}
            style={{
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Home
          </button>
          <button
            type="button"
            onClick={handleLogout}
            style={{
              padding: "10px 20px",
              backgroundColor: "#dc3545",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotAllowed;
